export const CLOSING_DAY_DIALOG_ID = 'closing-day-dialog';
export const CLOSING_DAY_GRID_CODE = 'closing-day';
